'use strict'; // eslint-disable-line strict

var BiLoggerClientFactory = require('./bi-logger-factory');
var BiLogger = require('./bi-logger');
var biLoggerManager = require('./bi-logger-manager');
var BatchQueue = require('./utils/batch-queue');

module.exports.BiLoggerFactory = BiLoggerClientFactory;
module.exports.BiLogger = BiLogger;
module.exports.BiLoggerManager = biLoggerManager.BiLoggerManager;

module.exports.factory = function () {
  return new BiLoggerClientFactory();
};
module.exports.manager = biLoggerManager.manager;
module.exports.createBatchQueue = function () {
  return new BatchQueue();
};
//# sourceMappingURL=index.js.map